import { ApiError } from "@/lib/api.ts";

export function FatalScreen({ error }: { error: unknown }) {
  const message =
    error instanceof ApiError && error.status === 404
      ? "This address is not linked to an EDI service. Check the web address or contact your provider."
      : error instanceof Error
        ? error.message
        : "The service could not be reached.";
  return (
    <div className="flex h-full items-center justify-center bg-background p-6">
      <div className="max-w-md space-y-3 text-center">
        <div className="mx-auto h-10 w-10 rounded-full bg-destructive/10 text-destructive grid place-items-center text-lg font-semibold">!</div>
        <h1 className="text-lg font-semibold">We couldn’t load the service</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <button className="text-sm underline underline-offset-4" onClick={() => window.location.reload()}>
          Try again
        </button>
      </div>
    </div>
  );
}
